export default __webpack_public_path__ + "static/media/education.60f19aec.png";